export const splitBy = (value: string, delimiter: string) => {
  try {
    return value.split(delimiter)[0];
  } catch {
    return value;
  }
};
